













import { Component, Vue } from 'vue-property-decorator';
import { ToastType } from '@easygenerator/fragment-sdk';
interface IToast {
  message: string;
  type: string;
  isActive: boolean;
}

@Component
export default class ToastNotification extends Vue {
  toasts: IToast[] = [];

  created() {
    window.eventBus.$on('toast:show', ({ type, message }: { type: ToastType; message: string }) => {
      this.showToast({ type, message });
    });
  }

  showToast({ type, message }: { type: ToastType; message: string }) {
    if (this.toasts.some(toast => toast.message === message && toast.type === type)) {
      this.refreshToastAnimation({ type, message });
      return;
    }

    this.addToast({ type, message });
  }

  async refreshToastAnimation({ type, message }: { type: ToastType; message: string }) {
    const toastIndex = this.toasts.findIndex(toast => toast.message === message);
    this.removeToast(toastIndex);

    await this.$nextTick();
    this.addToast({ type, message });
  }

  addToast({ type, message }: { type: ToastType; message: string }) {
    this.toasts.push({ message, type, isActive: true });
  }

  removeToast(index: number) {
    this.toasts.splice(index, 1);
  }
}
